// src/components/reasons/ReasonsSection.js
import React from 'react';
import ContactSection from '../contact/ContactSection';
import './ReasonsSection.css';

const ReasonsSection = () => {
  return (
    <section className="reasons-section">
      {/* Main content container */}
      <div className="reasons-container">
        {/* Title section (ttl) */}
        <div className="reasons-title-container">
          <div className="frame-48098446">
            <div className="rectangle-87">
              <img 
                src={process.env.PUBLIC_URL + '/images/hogoland_logo.png'} 
                alt="ほごらんど" 
                className="hogoland-logo"
              />
            </div>
            <div className="frame-48098445">
              <h2 className="reasons-title">
                <span className="orange-number">
                  <img 
                    src={process.env.PUBLIC_URL + '/images/three.png'} 
                    alt="3" 
                    className="number-image"
                  />
                </span>
                <span className="title-text">が選ばれる つの理由</span>
              </h2>
            </div>
          </div>
        </div>
        
        {/* Reasons content (Frame 48098447) */}
        <div className="reasons-content-container">
          {/* Reason 1 - Image on left (Frame 153) */}
          <div className="reason-item">
            <div className="reason-image-container">
              <img 
                src={process.env.PUBLIC_URL + '/images/point1_photo.jpg'} 
                alt="全てが無料" 
                className="reason-image"
              />
            </div>
            <div className="reason-text-block">
              <div className="reason-text-content">
                <div className="reason-text-header">
                  <div className="reason-point-container">
                    <div className="point-text">POINT</div>
                    <div className="point-number">01</div>
                  </div>
                  <h3 className="reason-subtitle">完全無料サポート</h3>
                </div>
                <div className="subtitle-line"></div>
                <div className="reason-description">
                  <p>「相談したらお金がかかるのでは？」と不安な方も安心。 ほごらんどでは生活保護の申請手続き、住居の確保、生活支援など、<span className="marker-text">すべて無料でサポート</span>します！専門のスタッフが書類の準備から申請手続きまでフルサポートし、過去に申請を断られた方でも、成功率99%のノウハウで受給へ導きます。</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Reason 2 - Image on right (Frame 154) */}
          <div className="reason-item">
            <div className="reason-image-container reason-image-right">
              <img 
                src={process.env.PUBLIC_URL + '/images/point2_photo.png'} 
                alt="即日対応・即日入居可能" 
                className="reason-image"
              />
            </div>
            <div className="reason-text-block reason-text-left">
              <div className="reason-text-content">
                <div className="reason-text-header">
                  <div className="reason-point-container">
                    <div className="point-text">POINT</div>
                    <div className="point-number">02</div>
                  </div>
                  <h3 className="reason-subtitle">即日入居可能！緊急対応も安心</h3>
                </div>
                <div className="subtitle-line"></div>
                <div className="reason-description">
                  <p>「今すぐ住む場所がほしい…」「今夜の寝る場所がない…」そんな緊急の状況でも、<span className="marker-text">当日中に入居可能な物件を迅速にご案内</span>。豊富な物件情報を元に、できるだけ短期間で生活を安定させられるようサポートします。どんなに急な状況でも、安心してお任せいただけます。</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Reason 3 - Image on left (Frame 155) */}
          <div className="reason-item">
            <div className="reason-image-container">
              <img 
                src={process.env.PUBLIC_URL + '/images/point3_photo.jpg'} 
                alt="専門家が同行" 
                className="reason-image"
              />
            </div>
            <div className="reason-text-block">
              <div className="reason-text-content">
                <div className="reason-text-header">
                  <div className="reason-point-container">
                    <div className="point-text">POINT</div>
                    <div className="point-number">03</div>
                  </div>
                  <h3 className="reason-subtitle">すぐに快適な暮らしを始められる体制</h3>
                </div>
                <div className="subtitle-line"></div>
                <div className="reason-description">
                  <p>冷蔵庫・洗濯機・布団など、<span className="marker-text">生活に必要な家具・家電を完備</span>。荷物がほとんどなくても、すぐに快適な生活を始められます。さらに、<span className="marker-text">希望者限定で1日3食の食事支援</span>も行っているため、自炊が難しい方や体調を崩しがちな方も、ご安心ください。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Contact Section */}
      <div className="reasons-contact-wrapper">
        <ContactSection />
      </div>
    </section>
  );
};

export default ReasonsSection;